const doc = [({"da":({"js":({"shared":({"create_card":({"the_model_was_created":"Modellen blev oprettet"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;